import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from "@azure/msal-angular";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  PopupRequest,
  RedirectRequest,
} from "@azure/msal-browser";
import { ButtonModule } from "primeng/button";
import { filter, Subject, takeUntil } from "rxjs";
import { Toast } from "primeng/toast";
import { UserManagementService } from "../../core/services/user-management.service";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { ValidateLogin } from "../../core/models/validate-login.dto";
import { MessageService } from "primeng/api";

@Component({
  selector: "jni-login",
  imports: [ButtonModule, Toast],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
  providers: [MessageService],
})
export class LoginComponent implements OnInit, OnDestroy {
  isIframe = false;
  loginDisplay = false;
  validateLoginRes!: unknown;
  // public userRoleInfo!: any;

  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private _userManagement: UserManagementService,
    private _router: Router,
    private _toastr: MessageService
  ) {}

  ngOnInit(): void {
    const msal = this.authService as import("@azure/msal-angular").MsalService;

    msal.handleRedirectObservable().subscribe(() => {
      this.msalBroadcastService.msalSubject$
        .pipe(
          filter(
            (msg: EventMessage) =>
              msg.eventType === EventType.ACCOUNT_ADDED ||
              msg.eventType === EventType.ACCOUNT_REMOVED
          )
        )
        .subscribe(() => {
          if (msal.instance.getAllAccounts().length === 0) {
            window.location.pathname = "/";
          } else {
            if (!msal.instance.getAllAccounts().length) {
              this.loginRedirect();
            }
            //this.setLoginDisplay();
          }
        });

      this.msalBroadcastService.inProgress$
        .pipe(
          filter(
            (status: InteractionStatus) => status === InteractionStatus.None
          ),
          takeUntil(this._destroying$)
        )
        .subscribe(() => {
          this.checkAndSetActiveAccount();
          const isLoggedIn = msal.instance.getAllAccounts().length > 0;
          if (isLoggedIn) {
            this.validateLogin(false);
          }
        });
    });
  }

  setLoginDisplay(): void {
    const msalInstance = this.authService
      .instance as unknown as import("@azure/msal-browser").PublicClientApplication;
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length > 0) {
      this.loginDisplay = true;

      if (this.loginDisplay) {
        this._router.navigate(["dashboard"]);
      }
    }
  }

  checkAndSetActiveAccount() {
    const msalInstance = this.authService
      .instance as unknown as import("@azure/msal-browser").PublicClientApplication;

    const activeAccount = msalInstance.getActiveAccount();

    if (!activeAccount && msalInstance.getAllAccounts().length > 0) {
      const accounts = msalInstance.getAllAccounts();
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  loginRedirect() {
    const msal = this.authService as import("@azure/msal-angular").MsalService;

    if (this.msalGuardConfig.authRequest) {
      msal.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      msal.loginRedirect();
    }
  }

  loginPopup() {
    const msal = this.authService as import("@azure/msal-angular").MsalService;

    if (this.msalGuardConfig.authRequest) {
      msal
        .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
    } else {
      msal.loginPopup().subscribe((response: AuthenticationResult) => {
        this.authService.instance.setActiveAccount(response.account);
      });
    }
  }

  logout(popup?: boolean) {
    const msal = this.authService as import("@azure/msal-angular").MsalService;

    if (popup) {
      msal.logoutPopup({
        mainWindowRedirectUri: "/",
      });
    } else {
      msal.logoutRedirect();
    }
  }

  validateLogin(withMessage: boolean): void {
    this._userManagement.validateLogin().subscribe({
      next: (res: GenericResponseDto<ValidateLogin>) => {
        //this.userRoleInfo = res.data;
        //this._dataService.userRole.next(res.data);
        //this._signalRService.createConnection();
        this.validateLoginRes = res;
        if (!withMessage) {
          this.setLoginDisplay();
          this._toastr.add({
            severity: "success",
            summary: "Success",
            detail: "Logged In Successfully!",
            life: 3000,
            sticky: true,
          });
        }
      },
      error: err => {
        //this.showLoader = false;
        console.error("jniportal-validateLogin", err);
      },
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
